<template>
  <li class="game-condition-item">
    <svg-icon name="Level32" kind="indicative" />
    <span>{{ t("gamification_game_condition_level_label") }}</span>
    <cv-number-input
      id="level"
      v-model="level"
      max="99"
      min="0"
      :invalid-message="validationErrors.level"
      :disabled="disableFields"
      @input="handleLevelInput"
      @change="handleLevelChange"
    />
    <span>{{ t("gamification_game_condition_level_is_achieved_label") }}</span>
    <cv-button kind="ghost" class="icon-button btn-delete-condition">
      <svg-icon name="Trash24" kind="action" @click="deleteCondition" />
    </cv-button>
  </li>
</template>

<script setup lang="ts">
import ValidationMixin from "@utils/mixin/validation.mixin";
import { nextTick, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useVm } from "@utils/vm.ts";

defineOptions({
  mixins: [ValidationMixin],
});

const { vm } = useVm();
const { t } = useI18n();
const emit = defineEmits(["change", "delete"]);

// Props
interface Props {
  condition: Record<string, unknown>;
  disableFields?: boolean;
  validationErrors?: Record<string, unknown>;
}

const { condition, disableFields = false, validationErrors = {} } = defineProps<Props>();

// Data
const level = ref(condition.levelPrerequisite);
const previousLevelValue = ref(condition.levelPrerequisite);

// Methods
const handleLevelInput = function (event) {
  const value = event.target.valueAsNumber;
  if (!vm.validateNumberInput(value, { min: 0, max: 99 })) {
    return;
  }
  level.value = value;
  previousLevelValue.value = value;
  emit("change", {
    targetId: condition.id,
    level: value,
  });
};

const handleLevelChange = function (e) {
  const value = e.target.valueAsNumber;
  if (!vm.validateNumberInput(value, { min: 0, max: 99 })) {
    nextTick(() => {
      level.value = previousLevelValue.value;
    });
    return;
  }
  previousLevelValue.value = value;
  emit("change", {
    targetId: condition.id,
    level: value,
  });
};

const deleteCondition = function () {
  emit("delete", condition.id);
};

// Watch
watch(
  () => condition.levelPrerequisite,
  (value) => {
    level.value = value;
  },
);
</script>
